<template>
  <!-- style="--main-color: initial" -->
  <div id="app" @scroll="handleScroll()">
    <main class="content-main">
      <!-- DEFINE MENU -->
      <Menu
        v-if="
          ['Login', 'Polity', 'Terms', 'DeleteAccount'].indexOf($route.name) ===
          -1
        "
      />
      <!-------------------->
      <div
        class="content-main--div"
        :class="{
          'content-main--div--login':
            ['Login', 'Polity', 'Terms', 'DeleteAccount'].indexOf($route.name) >
            -1,
        }"
      >
        <!-- DEFINE HEADER -->
        <Header
          :isScrolled="isScrolled"
          :isScrolledMobile="isScrolledMobile"
          v-if="
            ['Login', 'Polity', 'Terms', 'DeleteAccount'].indexOf(
              $route.name
            ) === -1
          "
        />
        <!-------------------->
        <router-view />
      </div>
    </main>

    <!-- COMPONENT LOADING -->
    <Loading />
    <!------------------------>

    <!--- BACKDROP -->
    <div class="backdrop_bar d-none"></div>
    <!-------------------->

    <!-- MODAL CATEGORIES -->
    <ModalCategory />
    <!-------------------->
  </div>
</template>

<style lang="scss">
@import "./assets/scss/generic/mixins.scss";
@import "./assets/scss/generic/fonts.scss";
@import "./assets/scss/generic/utilities.scss";

:root {
  --white: #fff;
  --black: #000;
  --gray-light: #e5e5e5;
  --gray-light-2: #f9f9f9;
  --gray-medium: #d9d9d9;
  --gray-1: #d6d6d6;
  --gray-2: #c4c4c4;
  --gray-dark: #707070;
  --blue: #06adf4;
  --blue-2: #029cdc;
  --red-light: #f95353;
  --red: #f95303;
  --red-medium: #f11717;
  --red-dark: #ef0000;
  --red-super-dark: #cc0000;
  --red-2: #fc0005;
  --orange: #fdae02;
  --orange-2: #ff8e14;
  --green-light: #95d6a4;
  --green: #10cd00;
  --green-2: #08c233;
  --green-dark: #50a773;
  --green-super-dark: #058823;
  --yellow-light: #e9e094;
  --yellow: #faff2c;
  --yellow-2: #ffec04;
  --yellow-dark: #eccc24;
}
html,
body {
  margin: 0;
  width: 100%;
  color: #687188;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.swiper-button-next,
.swiper-button-prev {
  outline: none !important;
  &::after {
    content: none;
  }
}
.swiper-container .swiper-button-next,
.swiper-container .swiper-button-prev {
  background: 0;
  border: 0;
}
.overflow-hidden {
  overflow: hidden;
}
.backdrop_bar {
  position: fixed;
  z-index: 2;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.6);
}
a {
  text-decoration: none !important;
}
button {
  outline: none !important;
}
.content-main {
  display: flex;
  &--div {
    width: calc(100% - 300px);
    padding: 0px 30px;
    @media (max-width: 991px) {
      width: 100%;
      padding: 0px 15px;
    }
    &--login {
      width: 100%;
      padding: 0;
    }
  }
}
.content-input-default {
  margin-bottom: 30px;
  input,
  textarea {
    width: 100%;
    height: 40px;
    font-size: 16px;
    font-family: "Font Regular";
    color: var(--black);
    border: 0;
    border-bottom: 1px solid rgba(255, 142, 20, 0.3);
    padding: 0px 20px;
    transition: 500ms;
    &::-webkit-input-placeholder {
      /* Chrome/Opera/Safari */
      font-family: "Font Light";
      color: rgba(0, 0, 0, 0.3);
    }
    &::-moz-placeholder {
      /* Firefox 19+ */
      font-family: "Font Light";
      color: rgba(0, 0, 0, 0.3);
    }
    &:-ms-input-placeholder {
      /* IE 10+ */
      font-family: "Font Light";
      color: rgba(0, 0, 0, 0.3);
    }
    &:-moz-placeholder {
      /* Firefox 18- */
      font-family: "Font Light";
      color: rgba(0, 0, 0, 0.3);
    }
    &:not(:placeholder-shown) {
      border-color: var(--orange-2);
    }
    &:disabled {
      opacity: 0.3;
      pointer-events: none;
    }
  }
  textarea {
    min-height: 120px;
    resize: none;
  }
  &-select {
    position: relative;
    margin-bottom: 30px;
    label {
      width: 100%;
      text-align: left;
      font-size: 18px;
      font-family: "Font Semibold";
      color: var(--black);
    }
    select {
      width: 100%;
      height: 40px;
      font-size: 16px;
      font-family: "Font Light";
      color: rgba(0, 0, 0, 0.4);
      border: 0;
      border-bottom: 1px solid rgba(255, 142, 20, 0.3);
      padding: 0px 20px;
      appearance: none;
      -moz-appearance: none;
      -webkit-appearance: none;
      transition: 500ms;
      &.content-input-default-select--active {
        font-family: "Font Regular";
        color: var(--black);
        border-color: var(--orange-2);
      }

      option:disabled {
        background: var(--yellow-dark);
        color: var(--white);
        font-family: "Font Semibold";
      }
    }
    svg {
      position: absolute;
      right: 5px;
      top: 50%;
      transform: translateY(-50%) rotate(90deg);
      width: 10px;
      pointer-events: none;
    }
    &--active {
      select {
        font-family: "Font Regular";
        color: var(--black);
        border-color: var(--orange-2);
      }
    }
    &--disabled {
      pointer-events: none;
      opacity: 0.6;
    }
  }
  &-check {
    display: flex;
    align-items: flex-start;
    margin-bottom: 30px;
    &:last-child {
      margin-bottom: 0;
    }
    input[type="checkbox"]:checked {
      border: 0;
    }
    input[type="checkbox"]:checked:before {
      content: "";
      height: 100%;
      width: 100%;
      background: url("~@/assets/img/checked.png");
      background-position: center !important;
      background-repeat: no-repeat !important;
    }
    input[type="checkbox"]:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      background-color: var(--white);
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 100%;
      border: 0;
    }
    input[type="checkbox"] {
      position: relative;
      height: 25px;
      width: 25px;
      border-radius: 100%;
      border: 1px solid rgba(0, 0, 0, 0.2);
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      outline: 0 !important;
      margin: 0;
      margin-right: 15px;
    }
    label {
      font-size: 14px;
      font-family: "Font Light";
      color: var(--black);
      width: calc(100% - 45px);
      text-align: left;
      line-height: 1.4;
      margin-bottom: 0;
      a {
        font-family: "Font Regular";
        color: var(--yellow-dark) !important;
        transition: 500ms;
        &:hover,
        &:focus {
          cursor: pointer;
          opacity: 0.8;
        }
      }
    }
  }
  label {
    width: 100%;
    text-align: left;
    font-size: 18px;
    font-family: "Font Semibold";
    color: var(--black);
  }
  span {
    display: block;
    width: 100%;
    text-align: left;
    font-size: 12px;
    font-family: "Font Light";
    color: var(--gray-dark);
    padding: 0 20px;
  }
  &--disabled {
    opacity: 0.3;
    pointer-events: none;
  }
  .disabled-text {
    font-size: 12px;
    font-family: "Font Light";
    color: var(--red-super-dark);
  }
}
.content-input-default-two {
  margin-bottom: 30px;
  input,
  textarea {
    width: 100%;
    height: 40px;
    font-size: 16px;
    font-family: "Font Regular";
    color: var(--black);
    border: 0;
    border-bottom: 1px solid var(--gray-light);
    padding: 0px 20px;
    transition: 500ms;
    &::-webkit-input-placeholder {
      /* Chrome/Opera/Safari */
      font-family: "Font Light";
      color: rgba(0, 0, 0, 0.4);
    }
    &::-moz-placeholder {
      /* Firefox 19+ */
      font-family: "Font Light";
      color: rgba(0, 0, 0, 0.4);
    }
    &:-ms-input-placeholder {
      /* IE 10+ */
      font-family: "Font Light";
      color: rgba(0, 0, 0, 0.4);
    }
    &:-moz-placeholder {
      /* Firefox 18- */
      font-family: "Font Light";
      color: rgba(0, 0, 0, 0.4);
    }
    &:not(:placeholder-shown) {
      border-color: var(--gray-2);
    }
  }
  textarea {
    min-height: 120px;
    resize: none;
  }
  &-select {
    position: relative;
    margin-bottom: 30px;
    select {
      width: 100%;
      height: 40px;
      font-size: 16px;
      font-family: "Font Light";
      color: rgba(0, 0, 0, 0.4);
      border: 0;
      border-bottom: 1px solid var(--gray-light);
      padding: 0px 20px;
      appearance: none;
      -moz-appearance: none;
      -webkit-appearance: none;
      transition: 500ms;
    }
    svg {
      position: absolute;
      right: 5px;
      top: 50%;
      transform: translateY(-50%) rotate(90deg);
      width: 10px;
      pointer-events: none;
    }
    &--active {
      select {
        font-family: "Font Regular";
        color: var(--black);
        border-color: var(--gray-2);
      }
    }
  }
  &-check {
    display: flex;
    align-items: flex-start;
    margin-bottom: 30px;
    &:last-child {
      margin-bottom: 0;
    }
    input[type="checkbox"]:checked {
      border: 0;
    }
    input[type="checkbox"]:checked:before {
      content: "";
      height: 100%;
      width: 100%;
      background: url("~@/assets/img/checked.png");
      background-position: center !important;
      background-repeat: no-repeat !important;
    }
    input[type="checkbox"]:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      background-color: var(--white);
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 100%;
      border: 0;
    }
    input[type="checkbox"] {
      position: relative;
      height: 25px;
      width: 25px;
      border-radius: 100%;
      border: 1px solid rgba(0, 0, 0, 0.2);
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      outline: 0 !important;
      margin: 0;
      margin-right: 15px;
    }
    label {
      font-size: 14px;
      font-family: "Font Light";
      color: var(--black);
      width: calc(100% - 45px);
      text-align: left;
      line-height: 1.4;
      margin-bottom: 0;
      a {
        font-family: "Font Regular";
        color: var(--yellow-dark) !important;
        transition: 500ms;
        &:hover,
        &:focus {
          cursor: pointer;
          opacity: 0.8;
        }
      }
    }
  }
}
.content-our-photo {
  position: relative;
  margin-bottom: 50px;
  &--title {
    text-align: left;
    margin-bottom: 10px;
    h2 {
      font-size: 16px;
      font-family: "Font Light";
      color: var(--black);
      margin-bottom: 0;
    }
  }
  &-body {
    position: relative;
    display: flex;
    align-items: center;
    padding-bottom: 20px;
    input {
      position: absolute;
      left: 0;
      opacity: 0;
      cursor: pointer;
    }
    .btn--new-photo {
      width: 100px;
      height: 100px;
      padding: 0;
      background: var(--white);
      border: 0;
      box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.25);
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-right: 15px;
      margin-bottom: 0;
      z-index: 1;
      cursor: pointer;
    }
    &-image {
      position: relative;
      &--bg {
        display: block;
        width: 100px;
        height: 100px;
        padding: 0;
        background-repeat: no-repeat !important;
        background-position: center !important;
        background-size: cover !important;
        box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.25);
        border: 0;
        border-radius: 10px;
      }
      .btn-remove-photo {
        position: absolute;
        top: -5px;
        right: -5px;
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: var(--white);
        border: 0;
        border-radius: 100%;
        box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.25);
        padding: 0;
        transition: 500ms;
        &:hover,
        &:focus {
          cursor: pointer;
          opacity: 0.8;
        }
      }
    }
    &--proportion {
      position: absolute;
      left: 0;
      bottom: 0;
      font-size: 10px;
      font-family: "Font Semibold";
      color: var(--black);
    }
  }
}
.btn-green {
  width: 100%;
  max-width: 250px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(to bottom, var(--green), var(--green-dark));
  border: 0;
  border-radius: 30px;
  font-size: 20px;
  font-family: "Font Bold";
  color: var(--white);
  text-transform: uppercase;
  margin: 0 auto;
  transition: 500ms;
  &:hover,
  &:focus {
    cursor: pointer;
    opacity: 0.8;
  }
}
.btn-yellow {
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--yellow);
  border: 0;
  border-radius: 30px;
  padding: 0px 15px;
  margin-right: 20px;
  margin-bottom: 10px;
  transition: 500ms;
  @media (max-width: 991px) {
    margin-bottom: 0;
    width: initial;
  }
  svg {
    fill: var(--black);
    transition: 500ms;
  }
  &:hover,
  &:focus {
    background: var(--black);
    p {
      color: var(--yellow);
    }
    svg {
      fill: var(--yellow);
    }
  }
  p {
    font-size: 16px;
    font-family: "Font Semibold";
    color: var(--black);
    transition: 500ms;
    margin-bottom: 0;
  }
}
.btn-green--small {
  padding: 0px 20px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #28a745;
  border: 0;
  border-radius: 20px;
  font-size: 16px;
  font-family: "Font Regular";
  color: #fff;
  text-transform: uppercase;
  transition: 500ms;
  &:hover,
  &:focus {
    cursor: pointer;
    opacity: 0.8;
  }
}
.content--card-register {
  width: 100%;
  height: calc(100% - 30px);
  min-height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--white);
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  margin-bottom: 30px;
  transition: 500ms;
  @media (max-width: 576px) {
    height: 180px;
  }
  &:hover,
  &:focus {
    cursor: pointer;
    opacity: 0.8;
  }
}
input,
select,
textarea,
button {
  outline: none;
}
.ql-toolbar {
  border-top-right-radius: 15px;
  border-top-left-radius: 15px;
}
.ql-container {
  height: 400px;
  border-bottom-right-radius: 15px;
  border-bottom-left-radius: 15px;
}
.content-menu-tasks {
  &-body {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding-bottom: 50px;
    &--link {
      width: calc(50% - 15px);
      height: 70px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: var(--white);
      box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.25);
      border-radius: 15px;
      padding: 0px 20px;
      margin-right: 15px;
      margin-bottom: 30px;
      transition: 500ms;
      &:nth-child(even) {
        margin-right: 0;
        margin-left: 15px;
      }
      @media (max-width: 767px) {
        width: 100%;
        margin-right: 0;
        margin-bottom: 20px;
        &:nth-child(even) {
          margin-left: 0;
        }
      }
      &:hover,
      &:focus {
        cursor: pointer;
        background: var(--yellow);
      }
      p {
        font-size: 20px;
        font-family: "Font Semibold";
        color: var(--black);
        margin-bottom: 0;
        @media (max-width: 991px) {
          font-size: 14px;
        }
      }
      .icon {
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: var(--yellow);
        border-radius: 100%;
      }
    }
  }
}
</style>
<script>
import { mapGetters } from "vuex";
import Header from "@/components/headers/Header";
import Menu from "@/components/menus/Menu";
import Loading from "@/components/loading/Index";
import ModalCategory from "@/components/modals/ModalCategory";

export default {
  data() {
    return {
      isScrolled: false,
      isScrolledMobile: false,
    };
  },
  components: {
    Header,
    Menu,
    Loading,
    ModalCategory,
  },
  computed: {
    ...mapGetters(["isDesktop"]),
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll(event) {
      if (event.currentTarget.innerWidth > 992) {
        if (event.currentTarget.scrollY > 100) {
          this.isScrolled = true;
        } else {
          this.isScrolled = false;
        }
      } else {
        if (event.currentTarget.scrollY > 100) {
          this.isScrolledMobile = true;
        } else {
          this.isScrolledMobile = false;
        }
      }
    },
  },
  mounted() {
    // if (window.innerWidth > 992){
    //   this.setIsDesktop(true);
    // } else {
    //   this.setIsDesktop(false);
    // }
  },
};
</script>
